import { orderedMenuItems } from "./constants";
export const mapMenuItemsToEntries = (menuGroup, services) => {
    return menuGroup
        .map(({ serviceIds, icon, label }) => {
        if (serviceIds.length === 0) {
            return null;
        }
        const primaryServiceId = serviceIds.find((serviceId) => services[serviceId]);
        if (!primaryServiceId) {
            return null;
        }
        const serviceLink = services[primaryServiceId];
        return { serviceId: primaryServiceId, serviceLink, icon, label };
    })
        .filter((entry) => entry !== null);
};
export const buildMenuStructure = (services) => {
    if (!services)
        return undefined;
    const firstSection = mapMenuItemsToEntries(orderedMenuItems.home, services);
    const secondSection = mapMenuItemsToEntries(orderedMenuItems.services, services);
    const restMatched = mapMenuItemsToEntries(orderedMenuItems.additionalServices, services);
    return {
        firstSection,
        secondSection,
        restMatched,
    };
};
//# sourceMappingURL=helpers.js.map